import React, { useState } from 'react';
import axios from 'axios';

const NewOpperFile = () => {
    const [file, setFile] = useState();
    const changeHandler = (e) =>
    {
        setFile(e.target.files[0]);
    }
    const submitData = () =>
    {
        const config = {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("AdminToken")}`,
            },
        };
        let formData = new FormData();
        formData.append('uploadfile', file);

        axios.post('https://arianaapp.arianaapply.com/uploadExcelFile-JobOpportunity', formData, config)
        .then(res=>{
            console.log('resFile', res);
        }).catch(err=>{
            console.log('err', err);
        })
    };
    console.log('file', file);
    return (
            <div className="index">
            <div className='form-custom'>
                <h2>آپلود دیتا از فایل اکسل</h2>
                <div className='input-group-custom'>
                    <label>فایل اکسل</label>
                    <input name='file' type='file' onChange={changeHandler} />
                </div>
                <button onClick={submitData} className='btn-success'>ثبت</button>
                </div>
            </div>
    );
}
 
export default NewOpperFile;